const createOrUpdateUserDegreeDetailGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
    failure_response {
      res_status
      response
    }
  `;

  const successFields = `
    completion_percentage
  `;

  const mutation = `create_or_update_user_degree_details(user_degree_details_input: $user_degree_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
      mutation CreateOrUpdateUserDegreeDetails($user_degree_details_input: UserDegreeDetailsInput!) {
        ${mutation}
      }
    `,
      type: 'UserDegreeDetailsInput!'
    };
  else return { mutation, type: 'UserDegreeDetailsInput!' };
};

export { createOrUpdateUserDegreeDetailGraphQlMutation };
